export default {"src":"/_next/static/media/LastBlockBG.46bffa45.svg","height":490,"width":1213,"blurWidth":0,"blurHeight":0};